<script setup lang="ts">
import { Button } from "@/components/ui/button";
const colorMode = useColorMode();

const toggleTheme = () => {
  colorMode.preference = colorMode.preference === "dark" ? "light" : "dark";
};
</script>

<template>
  <Button
    variant="outline"
    @click="toggleTheme"
    class="relative cursor-pointer group dark:hover:bg-zinc-800"
  >
    <Icon
      name="radix-icons:moon"
      v-if="colorMode.preference === 'light'"
      class="h-[1.2rem] w-[1.2rem] transition-transform rotate-0 scale-100 group-hover:rotate-12 group-hover:scale-110"
    />
    <Icon
      name="radix-icons:sun"
      v-else
      class="h-[1.2rem] w-[1.2rem] transition-transform rotate-0 scale-100 group-hover:rotate-12 group-hover:scale-110"
    />
    <span class="sr-only">Toggle theme</span>
  </Button>
</template>
